<form [formGroup]="form" (ngSubmit)="aceptar()" appPermissionControl="P254F0001">
  <div class="form-row mt-3">
    <div class="form-field">
      <input pInputText type="text" formControlName="numero_Proceso" class="form-control" disabled appPermissionControl="P254K0001">
      <label>N° Ruta</label>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field">
      <p-dropdown appendTo="body" [options]="actividades" optionLabel="descripcion" optionValue="numero_actividad"
        formControlName="comenzarActividad" placeholder="Comenzar Actividad" [filter]="true" appPermissionControl="P254K0002"></p-dropdown>
      <label>Comenzar Actividad</label>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field">
      <p-dropdown appendTo="body" [options]="actividades" optionLabel="descripcion" optionValue="numero_actividad"
        formControlName="terminarActividad" placeholder="Terminar Actividad" [filter]="true" appPermissionControl="P254K0003"></p-dropdown>
      <label>Terminar Actividad</label>
    </div>
  </div>

  <div class="button-section">
    <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!form.valid" appPermissionControl="P254B0001">
      <mat-icon>check</mat-icon>
      Aceptar
    </button>
  </div>
</form>

<style>
  :host ::ng-deep .form-row {
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
  }

  :host ::ng-deep .form-field {
    flex: 1;
    display: flex;
    flex-direction: column-reverse;
    position: relative;
  }

  :host ::ng-deep .form-control {
    width: 100%;
    padding: 0.5rem;
    font-size: 1rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #e0e0e0 !important;
    color: #555 !important;
    opacity: 1 !important;
  }

  :host ::ng-deep .form-field label {
    font-size: 0.85rem;
    color: #6c757d;
    margin-bottom: 0.25rem;
  }

  :host ::ng-deep .button-section {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 1.5rem;
  }
</style> 